angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);



// WEBPACK FOOTER //
// ./node_modules/angular-ui-bootstrap/template/accordion/accordion.html.js